/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/18/22
 */

export const persistState = (key: string, state: any) => {
	try {
		localStorage.setItem(key, JSON.stringify(state));
	} catch (err: any) {
		console.error(`Error persisting state ${key}:`, err.message);
	}
}